<div class="position-relative">
  <div class="spinner-container" *ngIf="isLoading">
    <p-progress-spinner></p-progress-spinner>
  </div>
  <ng-container *ngFor="let prp of lookupPrps | uiFilter: searchTerm : ['label']">
    <div
      class="position-relative row form-group prop-elems"
      *ngIf="
           (prp.name === 'executeOnEvent' ? (lookupType === 'Query View' && currNodeType === 'formField') :  
          (['selectedFormFieldsFieldChange', 'selectedFormFieldsVariableChange'].includes(prp.name) &&
            (
              (prp.name === 'selectedFormFieldsFieldChange' && executeOnEvent?.includes('OnchangeofSelectedFormFields')) ||
              (prp.name === 'selectedFormFieldsVariableChange' && executeOnEvent?.includes('OnchangeofPageVariables'))
            )
          ) ||
          (
            !['selectedFormFieldsFieldChange', 'selectedFormFieldsVariableChange'].includes(prp.name) &&
            !(
              (lookupType === 'Query View' && prp.name === 'lookupToForeignkey') ||
              (lookupType === 'Foreignkey Index' && prp.name === 'lookupToQueryView')
            ) &&
            !(prp.name === 'outputMapping' && hideOutMap)
          )
      )"
>
      <label class="{{ prp.lblWidth }} col-form-label" for="lookup-select"
        >{{ prp.label }}
        <i
          class="fa fa-info-circle field-info"
          class="fa fa-info-circle field-info"
          showDelay="100"
          hideDelay="100"
          tooltipStyleClass="label-tooltip custom-tooltip-properties"
          pTooltip="{{ prp.info }}"
        ></i>
      </label>
      <div class="{{ prp.lblWidth }} input-ctrl" [ngClass]="prp.lblWidth === 'col-sm-6' ? 'pl-0' : 'pr-0'">
        <ng-container [ngSwitch]="prp.name">
          <ng-template [ngSwitchCase]="'lookupType'">
            <p-select
              [options]="lookupTypes"
              placeholder="Select"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              [(ngModel)]="lookupType"
              class="form-control form-control-sm"
              (onChange)="changeLkType($event)"
              inputId="lookup-select"
            >
            </p-select>
          </ng-template>
          <ng-template [ngSwitchCase]="'lookupDisplayType'">
            <p-select
              [options]="displayTypes"
              placeholder="Select"
              optionLabel="label"
              optionValue="value"
              appendTo="body"
              [(ngModel)]="lookupDisplayType"
              class="form-control form-control-sm"
              readonly="true"
              inputId="lookup-select"
            >
            </p-select>
          </ng-template>
          <ng-template [ngSwitchCase]="'lookupToForeignkey'">
            <p-select
              [options]="foreignKeys"
              placeholder="Select"
              optionLabel="fkName"
              optionValue="sid"
              [(ngModel)]="lookupToForeignkey"
              (onChange)="changeFk($event)"
              [ngModelOptions]="{ standalone: true, updateOn: 'change' }"
              class="form-control form-control-sm wrap-dropdown"
              [showClear]="true"
              [filter]="true"
              [resetFilterOnHide]="true"
              inputId="lookup-select"
              appendTo="body"
            >
            </p-select>
          </ng-template>
          <ng-template [ngSwitchCase]="'lookupToQueryView'">
            <p-select
              [options]="queryTbls"
              placeholder="Select"
              optionLabel="tableName"
              [ngModelOptions]="{ standalone: true, updateOn: 'change' }"
              optionValue="tableId"
              [(ngModel)]="lookupToQueryView"
              (onChange)="changeQueryTbl($event)"
              class="form-control form-control-sm wrap-dropdown"
              [showClear]="true"
              [filter]="true"
              [resetFilterOnHide]="true"
              inputId="lookup-select"
              appendTo="body"
            >
            </p-select>
          </ng-template>
          <ng-template [ngSwitchCase]="'lookupDefinition'">
            <p-select
              [options]="lookupDefs"
              placeholder="Select"
              optionLabel="name"
              optionValue="sid"
              [ngModelOptions]="{ standalone: true, updateOn: 'change' }"
              [(ngModel)]="lookupDefinition"
              class="form-control form-control-sm wrap-dropdown"
              (onChange)="changeLookup($event)"
              [showClear]="true"
              appendTo="body"
              inputId="lookup-select"
            >
            </p-select>
          </ng-template>
          <ng-template [ngSwitchCase]="'executeOnEvent'">
            <p-multiSelect 
              [options]="executeOnEvents" 
              placeholder="Select Execute On Events" 
              optionLabel="label" 
              optionValue="value"
              (onClear)="handleClear()" 
              [(ngModel)]="executeOnEvent"
              [ngModelOptions]="{standalone: true, updateOn:'change'}"
              class="form-control form-control-sm wrap-dropdown" 
              (onChange)="set()"
              [maxSelectedLabels]="2"
              selectedItemsLabel="{0} events selected"
              [showClear]="true"
              appendTo="body"
              [closeOnSelect]="false"
              [disabled]="lookupType === 'Query View' && (!lookupToQueryView || !lookupDefinition)">
              <ng-template let-option pTemplate="item">
              <span>{{ option.label }}</span>
              </ng-template>
            </p-multiSelect>
          </ng-template>

          <ng-template [ngSwitchCase]="'displayFields'">
            <p-multiselect
              [options]="displayFieldOps"
              [(ngModel)]="displayFields"
              appendTo="body"
              optionLabel="name"
              [maxSelectedLabels]="3"
              disabled
              selectedItemsLabel="{0} items selected"
              class="multiselect-style dis-fld-mul-select"
              *ngIf="lookupType === 'Query View'"
              inputId="lookup-select"
            >
              <ng-template let-possibleValue pTemplate="item">
                <div class="options-item">
                  <div>{{ possibleValue.name }}</div>
                </div>
              </ng-template>
            </p-multiselect>
            <div class="section-table-container lookup-tbl w-100" *ngIf="lookupType !== 'Query View'">
              <p-table
                [value]="displayFields"
                lass="fil-map-table"
                [showGridlines]="true"
                [style]="{ width: '100%' }"
                [scrollable]="true"
              >
                <ng-template #header>
                  <tr>
                    <th>{{ 'REF_FLD' | translate }}</th>
                    <th>{{ 'DIS_FLD' | translate }}</th>
                  </tr>
                </ng-template>
                <ng-template #body let-data let-ri="rowIndex">
                  <tr>
                    <td>
                      <span>{{ data.referenceField?.name }}</span>
                    </td>
                    <td>
                      <div class="d-flex align-items-center position-relative"
                           [ngClass]="{
                             'display-field-container-nolonger': isDisplayFieldNoLonger(data)
                           }">
                        <span>{{ data.displayField?.name }}</span>
                        <span
                          *ngIf="isDisplayFieldNoLonger(data)"
                          class="pi pi-exclamation-circle display-field-errors-icon"
                          (click)="toggleErrorPopup(ri, 'error', 'displayFields')"
                          (keyup.enter)="toggleErrorPopup(ri, 'error', 'displayFields')"
                          tabindex="1"></span>
                        <div *ngIf="activePopupIndex === ri && popupType === 'error' && activePopupSection === 'displayFields'" class="dis-warning-popup-errors">
                          <div class="popup-header-errors">
                            <i class="pi pi-exclamation-circle"></i>
                            Error
                          </div>
                          <div class="popup-content-errors">
                            {{ 'FLD_NO_LONGER' | translate }}
                          </div>
                          <button class="close-btn-errors" (click)="closePopup()">×</button>
                        </div>
                      </div>
                    </td>
                  </tr>
                </ng-template>
                <ng-template #emptymessage>
                  <tr class="no-records">
                    <td colspan="2" class="text-center">
                      {{ 'NO_RECORDS_FOUND' | translate }}
                    </td>
                  </tr>
                </ng-template>
              </p-table>
            </div>
          </ng-template>
          <ng-template [ngSwitchCase]="'inputMapping'">
            <div class="lookupfilter-body">
              <div class="section-table-container lookup-tbl">
                <p-table
                  [value]="inputMapping"
                  lass="fil-map-table"
                  [showGridlines]="true"
                  [style]="{ width: '100%' }"
                  [scrollable]="true"
                >
                  <ng-template #header>
                    <tr>
                      <th>
                        {{ (lookupType === 'Foreignkey Index' ? 'FK_LOOKUP_FIELD' : 'QV_LOOKUP_FIELD') | translate }}
                      </th>
                      <th></th>
                      <th>{{ 'MAP_FROM_FIELD' | translate }}</th>
                    </tr>
                  </ng-template>
                  <ng-template #body let-data let-ri="rowIndex">
                    <tr>
                      <td>
                        <span
                          [class.required]="
                            lookupType === 'Query View' &&
                            this.tblProps?.t_mandatory_filters?.includes(data.lookupField?.sid)
                          "
                          >{{ data.lookupField.name }}</span
                        >
                      </td>
                      <td class="arrow-denotation">
                        <i class="pi pi-arrow-left"></i>
                      </td>
                      <td class="td-mapping-field">
                        <div class="d-flex align-items-center position-relative" 
                             [ngClass]="{
                               'input-mapping-container-nolonger': isInputMappingFieldNoLonger(data),
                               'input-mapping-container-mismatch': isInputMappingFieldMismatch(data)
                             }"
                             *ngIf="lookupType !== 'Query View'">
                          <span>{{ data.tableField?.name }}</span>
                          <span
                            *ngIf="isInputMappingFieldMismatch(data)"
                            class="pi pi-exclamation-triangle input-mapping-warn-icon"
                            (click)="toggleErrorPopup(ri, 'warning', 'inputMapping-fk')"
                            (keyup.enter)="toggleErrorPopup(ri, 'warning', 'inputMapping-fk')"
                            tabindex="1"></span>
                          <span
                            *ngIf="isInputMappingFieldNoLonger(data)"
                            class="pi pi-exclamation-circle input-mapping-errors-icon"
                            (click)="toggleErrorPopup(ri, 'error', 'inputMapping-fk')"
                            (keyup.enter)="toggleErrorPopup(ri, 'error', 'inputMapping-fk')"
                            tabindex="1"></span>
                          <div *ngIf="activePopupIndex === ri && popupType === 'warning' && activePopupSection === 'inputMapping-fk'" class="input-warning-popup">
                            <div class="popup-header">
                              <i class="pi pi-exclamation-triangle"></i>
                              Warning
                            </div>
                            <div class="popup-content">
                              {{ 'FLD_MISMATCH' | translate }}
                            </div>
                            <button class="close-btn" (click)="closePopup()">×</button>
                          </div>
                          <div *ngIf="activePopupIndex === ri && popupType === 'error' && activePopupSection === 'inputMapping-fk'" class="input-warning-popup-errors">
                            <div class="popup-header-errors">
                              <i class="pi pi-exclamation-circle"></i>
                              Error
                            </div>
                            <div class="popup-content-errors">
                              {{ 'FLD_NO_LONGER' | translate }}
                            </div>
                            <button class="close-btn-errors" (click)="closePopup()">×</button>
                          </div>
                        </div>
                        <div class="autocomplete-wrapper d-flex align-items-center" *ngIf="lookupType === 'Query View'">
                          <p-autocomplete
                            [(ngModel)]="data.tableField"
                            [ngModelOptions]="{ standalone: true, updateOn: 'change' }"
                            [suggestions]="allFieldsFiltered"
                            (onSelect)="onfieldSel($event, ri, 'inputMapping')"
                            trim="blur"
                            appendTo="body"
                            (completeMethod)="showFilteredOptions('inputMapping', data.lookupField, $event)"
                            [dropdown]="true"
                            [forceSelection]="true"
                            field="name"
                            panelStyleClass="group-autocomplete"
                            placeholder="Select"
                            [showEmptyMessage]="true"
                            [group]="true"
                            [ngClass]="{
                               'input-mapping-container-nolonger': isInputMappingFieldNoLonger(data),
                               'input-mapping-container-mismatch': isInputMappingFieldMismatch(data)
                             }"
                          >
                            <ng-template let-field pTemplate="item">
                              <div class="field-item text-overflow">
                                <span>{{ field.name }}</span>
                              </div>
                            </ng-template>
                            <ng-template let-group #group>
                              <div class="flex align-items-center">
                                <span class="fw-bold">{{ group.name }}</span>
                              </div>
                            </ng-template>
                          </p-autocomplete>
                          <span
                            *ngIf="isInputMappingFieldMismatch(data)"
                            class="pi pi-exclamation-triangle mapping-warn-icon crossed-icon ml-1"
                            (click)="toggleErrorPopup(ri, 'warning', 'inputMapping-qv')"
                            (keyup.enter)="toggleErrorPopup(ri, 'warning', 'inputMapping-qv')"
                            tabindex="1"></span>
                          <span
                            *ngIf="isInputMappingFieldNoLonger(data)"
                            class="pi pi-exclamation-circle mapping-errors-icon crossed-icon ml-1"
                            (click)="toggleErrorPopup(ri, 'error', 'inputMapping-qv')"
                            (keyup.enter)="toggleErrorPopup(ri, 'error', 'inputMapping-qv')"
                            tabindex="1"></span>
                          <span
                            class="pi pi-times cursor-pointer ml-1"
                            *ngIf="data.tableField"
                            (click)="onRowDelete(ri, 'inputMapping')"
                            (keyup.enter)="onRowDelete(ri, 'inputMapping')"
                            tabindex="0"
                            aria-label="Row delete"
                          ></span>
                          <div *ngIf="activePopupIndex === ri && popupType === 'warning' && activePopupSection === 'inputMapping-qv'" class="warning-popup">
                            <div class="popup-header">
                              <i class="pi pi-exclamation-triangle"></i>
                              Warning
                            </div>
                            <div class="popup-content">
                              {{ 'FLD_MISMATCH' | translate }}
                            </div>
                            <button class="close-btn" (click)="closePopup()">×</button>
                          </div>
                          <div *ngIf="activePopupIndex === ri && popupType === 'error' && activePopupSection === 'inputMapping-qv'" class="warning-popup-errors">
                            <div class="popup-header-errors">
                              <i class="pi pi-exclamation-circle"></i>
                              Error
                            </div>
                            <div class="popup-content-errors">
                              {{ 'FLD_NO_LONGER' | translate }}
                            </div>
                            <button class="close-btn-errors" (click)="closePopup()">×</button>
                          </div>
                        </div>
                      </td></tr
                  ></ng-template>
                  <ng-template #emptymessage>
                    <tr class="no-records">
                      <td colspan="3" class="text-center">
                        {{ 'NO_RECORDS_FOUND' | translate }}
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </ng-template>
          <ng-template [ngSwitchCase]="'outputMapping'">
            <div class="lookupfilter-body">
              <div class="section-table-container lookup-tbl">
                <p-table
                  [value]="outputMapping"
                  class="fil-map-table"
                  [showGridlines]="true"
                  [style]="{ width: '100%' }"
                  [scrollable]="true"
                >
                  <ng-template pTemplate="header">
                    <tr>
                      <th>
                        {{
                          (lookupType === 'Foreignkey Index' ? 'FK_OUT_LOOKUP_FIELD' : 'QV_OUT_LOOKUP_FIELD')
                            | translate
                        }}
                      </th>
                      <th></th>
                      <th>{{ 'MAP_TO_FIELD' | translate }}</th>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="body" let-data let-ri="rowIndex">
                    <tr>
                      <td>
                        <span>{{ data.lookupField.name }}</span>
                      </td>
                      <td class="arrow-denotation">
                        <i class="pi pi-arrow-right"></i>
                      </td>
                      <td class="td-mapping-field">
                        <div class="table-mapping-column">
                          <div class="autocomplete-wrapper">
                          <p-autocomplete
                            [(ngModel)]="data.tableField"
                            [ngModelOptions]="{ standalone: true, updateOn: 'change' }"
                            [suggestions]="allFieldsFiltered"
                            (onSelect)="onfieldSel($event, ri, 'outputMapping')"
                            trim="blur"
                            appendTo="body"
                            [showEmptyMessage]="true"
                            (completeMethod)="showFilteredOptions('outputMapping', data.lookupField, $event)"
                            [dropdown]="true"
                            [forceSelection]="true"
                            field="name"
                            panelStyleClass="group-autocomplete"
                            placeholder="Select"
                            [group]="true"
                            [ngClass]="{
                              'fields-nolonger-warning': isOutputMappingFieldNoLonger(data),
                              'fields-mismatch-warning': isOutputMappingFieldMismatch(data)
                            }"
                          >
                            <ng-template let-field pTemplate="item">
                              <div class="field-item text-overflow">
                                <span>{{ field.name }}</span>
                              </div>
                            </ng-template>
                            <ng-template let-group #group>
                              <div class="flex align-items-center">
                                <span class="fw-bold">{{ group.name }}</span>
                              </div>
                            </ng-template>
                          </p-autocomplete>
                          <span
                            *ngIf="isOutputMappingFieldMismatch(data)"
                            class="pi pi-exclamation-triangle warn-icon crossed-icon ml-1"
                            (click)="toggleErrorPopup(ri, 'warning', 'outputMapping')"
                            (keyup.enter)="toggleErrorPopup(ri, 'warning', 'outputMapping')"
                            tabindex="1"></span>
                          <span
                            *ngIf="isOutputMappingFieldNoLonger(data)"
                            class="pi pi-exclamation-circle errors-icon crossed-icon ml-1"
                            (click)="toggleErrorPopup(ri, 'error', 'outputMapping')"
                            (keyup.enter)="toggleErrorPopup(ri, 'error', 'outputMapping')"
                            tabindex="1"></span>
                          <span
                            class="pi pi-times cursor-pointer ml-1 cross-mark"
                            *ngIf="data.tableField"
                            (click)="onRowDelete(ri, 'outputMapping')"
                            (keyup.enter)="onRowDelete(ri, 'outputMapping')"
                            tabindex="1"
                            aria-label="Row Delete"
                          ></span>
                          <div *ngIf="activePopupIndex === ri && popupType === 'warning' && activePopupSection === 'outputMapping'" class="warning-popup">
                            <div class="popup-header">
                              <i class="pi pi-exclamation-triangle"></i>
                              Warning
                            </div>
                            <div class="popup-content">
                              {{ 'FLD_MISMATCH' | translate }}
                            </div>
                            <button class="close-btn" (click)="closePopup()">×</button>
                          </div>
                          <div *ngIf="activePopupIndex === ri && popupType === 'error' && activePopupSection === 'outputMapping'" class="warning-popup-errors">
                            <div class="popup-header-errors">
                              <i class="pi pi-exclamation-circle"></i>
                              Error
                            </div>
                            <div class="popup-content-errors">
                              {{ 'FLD_NO_LONGER' | translate }}
                            </div>
                            <button class="close-btn-errors" (click)="closePopup()">×</button>
                          </div>
                        </div>
                        </div>
                      </td>
                    </tr>
                  </ng-template>
                  <ng-template pTemplate="emptymessage">
                    <tr class="no-records">
                      <td colspan="3" class="text-center">
                        {{ 'NO_RECORDS_FOUND' | translate }}
                      </td>
                    </tr>
                  </ng-template>
                </p-table>
              </div>
            </div>
          </ng-template>
              <ng-template [ngSwitchCase]="'selectedFormFieldsFieldChange'">
                <p-multiSelect 
                    *ngIf="executeOnEvent?.includes('OnchangeofSelectedFormFields')"
                    [options]="formFields" 
                    placeholder="Select" 
                    optionLabel="label" 
                    optionValue="value"
                    [(ngModel)]="selectedFormFieldsFieldChange"
                    [ngModelOptions]="{standalone: true, updateOn:'change'}"
                    class="wrap-dropdown" 
                    (onChange)="set()"
                    (onClear)="set()"
                    [maxSelectedLabels]="3"
                    selectedItemsLabel="{0} fields selected"
                    [showClear]="true"
                    appendTo="body">
                    <ng-template let-option pTemplate="item">
                        <span>{{ option.label }}</span>
                    </ng-template>
                </p-multiSelect>
            </ng-template>

            <ng-template [ngSwitchCase]="'selectedFormFieldsVariableChange'">
                <p-multiSelect 
                    *ngIf="executeOnEvent?.includes('OnchangeofPageVariables')"
                    [options]="pageVariables" 
                    placeholder="Select" 
                    optionLabel="name" 
                    optionValue="sid"
                    [(ngModel)]="selectedFormFieldsVariableChange"
                    [ngModelOptions]="{standalone: true, updateOn:'change'}"
                    class="wrap-dropdown" 
                    (onChange)="set()"
                    (onClear)="set()"
                    [maxSelectedLabels]="3"
                    selectedItemsLabel="{0} fields selected"
                    [showClear]="true"
                    appendTo="body">
                    <ng-template let-option pTemplate="item">
                        <span>{{ option.name }}</span>
                    </ng-template>
                </p-multiSelect>
            </ng-template>
        </ng-container>
      </div>
    </div>
  </ng-container>
</div>

